import {Response, User} from "../../model";
import {ApiBuilder} from "..";

const updateUserInfo = (builder: ApiBuilder) =>
  builder.mutation<
    User,
    {
      name?: string;
      surname?: string;
      email?: string;
      phone?: string;
      img?: string;
    }
  >({
    query: body => ({
      url: "/api/user/update-info",
      method: "PUT",
      body,
    }),
    transformResponse: (r: Response<User>) => r.data,
  });

export {updateUserInfo};
